import extra from '/assets/scripts/extra.js';
import forms from '/assets/scripts/forms.js';
import '/assets/scripts/icons.js';

document.addEventListener('DOMContentLoaded', async function () {
  extra();
  forms();

  if (document.querySelector('.slider-container')) {
    const { default: slider } = await import('/assets/scripts/slider.js');
    slider();
  }

  if (document.querySelector('.overview-veelgestelde_vragen, .alloy-pin-container, .alloy-filter')) {
    const { default: animation } = await import('/assets/scripts/animation.js');
    animation();
  }

  if (document.querySelector('.toggle-contrast, .font-size-controls, .toggle-reader, #reader-pause')) {
    const { default: accessibility } = await import('/assets/scripts/accessibility.js');
    accessibility();
  }

  if (document.querySelector('.ACF-locaties_kaart .locaties-map')) {
    const { default: locatiesMap } = await import('/assets/scripts/locaties-map.js');
    locatiesMap();
  }
});
